import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { AuthService } from '@app/_modules/auth/services/auth.service';
import { AUTH_TOKEN } from '@app/_interceptors/auth.interceptor';
import { APP_PATH, GROUPS } from '@app/app.constants';
import { Router } from '@angular/router';
import { Group } from '@app/definitions/interfaces';
import { AccountService } from '@app/teacher/services/account.service';
import { HandlerService } from '@app/_services/handler.service';

@Component({
    selector: 'app-registration-form',
    templateUrl: './registration-form.component.html',
    styleUrls: ['./registration-form.component.scss']
})
export class RegistrationFormComponent implements OnInit {
    @ViewChild('login', { static: true }) login: ElementRef;
    @ViewChild('email', { static: true }) email: ElementRef;
    @ViewChild('password', { static: true }) password: ElementRef;

    groups: Array<Group> = [];
    exclude_groups: Array<string> = [
        GROUPS.METODIST,
        GROUPS.NAVIGATOR,
        GROUPS.NAVIGATOR_JUNIOR,
        GROUPS.SUPER_NAVIGATOR,
        GROUPS.TEACHER,
        GROUPS.TEACHER_HELPER
    ];
    errors: Array<any>;
    form: FormGroup;
    hide = true;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private authService: AuthService,
        private accountService: AccountService,
        private handlerService: HandlerService
    ) {}

    ngOnInit() {
        this.authService.resetAuth();

        this.form = this.fb.group({
            login: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(35)]],
            email: ['', [Validators.required, Validators.minLength(7), Validators.maxLength(35), Validators.email]],
            password: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(30)]],
            group: ['', [Validators.required]]
        });
        this.authService.getGroups().subscribe(resp => {
            this.groups = resp.data.filter(item => !item.for_admin && !this.exclude_groups.includes(item.name));
            this.errors = resp.errors;

            if (this.groups) {
                this.form.patchValue({
                    group: this.groups[0].id
                });
            }
        });
    }

    onSubmit() {
        if (this.form.valid) {
            const { login, email, password, group } = this.form.value;
            const formData = {
                username: login,
                email: email,
                password: password,
                group_id: group
            };

            this.authService.signup(formData).subscribe(resp => {
                this.handlerService.checkErrors(resp);

                if (!resp.error) {
                    this.accountService.setCurrentGroupId(+group);
                    this.authService.login(formData).subscribe(response => {
                        if (response && !!response.token) {
                            localStorage.setItem(AUTH_TOKEN, response.token);
                            this.router.navigate([APP_PATH.home]);
                        }
                    });
                }
            });
        }
    }
}
